import { link } from 'autolinker';
import sanitize from 'sanitize-html';

export function safeLink(text: string): string {
  return link(
    sanitize(text, {
      allowedTags: [],
      allowedAttributes: {}
    }),
  { className: 'theme__default-link' });
}
